import {Chart} from './chart';
import {Selection as D3Selection} from 'd3';
import {Constants as constants} from '../config/constants';
import {Rect} from '@/types/primitives';

export class ArcLabelRenderer {
    private groupRect = null as unknown as Rect;
    private labels = {
        large: null as unknown as D3Selection<any, any, any, any>,
        small: null as unknown as D3Selection<any, any, any, any>,
        middle: null as unknown as D3Selection<any, any, any, any>
    };

    constructor(private chart: Chart) {
    }

    public render() {
        this.calculateGroupRect();
        this.renderText();
        this.normalizeText();
    }

    private calculateGroupRect() {
        const groupSize = this.chart.node.chart.node().getBBox();
        this.groupRect = {
            left: this.chart.toolList.pathRenderer.data.center.x - groupSize.width / 2,
            top: this.chart.toolList.pathRenderer.data.center.y - groupSize.height / 2,
            right: this.chart.toolList.pathRenderer.data.center.x + groupSize.width / 2,
            bottom: this.chart.toolList.pathRenderer.data.center.y + groupSize.height / 2
        };
    }

    private renderText() {
        this.labels.large = this.chart.node.chart
            .append('text')
            .text(constants.arcLabels.large)
            .attr('class', 'arc-label');

        this.labels.small = this.chart.node.chart
            .append('text')
            .text(constants.arcLabels.small)
            .attr('class', 'arc-label');

        this.labels.middle = this.chart.node.chart
            .append('text')
            .text(constants.arcLabels.middle)
            .attr('class', 'arc-label');
    }

    private normalizeText() {
        this.labels.large
            .attr('transform', `translate(${this.groupRect.right}, ${this.groupRect.top})`);

        this.labels.small
            .attr('transform', `translate(${this.groupRect.left}, ${this.groupRect.bottom})`);

        this.labels.middle
            .attr('transform', `translate(${this.groupRect.left}, ${this.groupRect.top})`);
    }
}
